/* RESPONSIBLE TEAM: team-standalone */
/* eslint-disable no-restricted-imports */
import {
  STANDALONE_MESSENGER_CONVERSATION_STARTED_TARGET,
  STANDALONE_MESSENGER_CONVERSATION_STARTED_TRIGGER,
  AT_CONVERSATION_START,
  TRIGGERABLE_BOT_TYPE,
  EVERYONE_PREDICATE,
  WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION,
} from 'embercom/lib/operator/custom-bots/constants';
import {
  matchBehaviors,
  objectTypes,
} from 'embercom/models/data/matching-system/matching-constants';
import StandaloneMessengerConversationStartedBotEditorConfig from 'embercom/objects/visual-builder/configuration/editor/standalone-messenger-conversation-started';

import CustomBotConfig from '../custom-bot';
import type { BotConfigTarget } from '../configuration';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export default class StandaloneMessengerConversationStartedBotConfig extends CustomBotConfig {
  get rolePredicateGroup() {
    return { predicates: [EVERYONE_PREDICATE] };
  }

  get target(): BotConfigTarget {
    return STANDALONE_MESSENGER_CONVERSATION_STARTED_TARGET;
  }

  get botType() {
    return TRIGGERABLE_BOT_TYPE;
  }

  get objectType() {
    return objectTypes.triggerableCustomBot;
  }

  get trigger() {
    return STANDALONE_MESSENGER_CONVERSATION_STARTED_TRIGGER;
  }

  get matchBehavior() {
    return matchBehaviors.transient;
  }

  get titleTranslationKey() {
    return 'operator.custom-bot.trigger.standalone-messenger-conversation-started.title';
  }

  get descriptionTranslationKey() {
    return 'operator.custom-bot.trigger.standalone-messenger-conversation-started.description';
  }

  get icon(): InterfaceIconName {
    return 'messenger';
  }

  get EditorConfigClass() {
    return StandaloneMessengerConversationStartedBotEditorConfig;
  }

  visibleToApp(app: any) {
    return app.canUseStandalone;
  }

  get selectableCustomBotType() {
    return true;
  }

  get requiredBillingFeature() {
    return 'bot_workflows';
  }

  get triggerContextType() {
    return AT_CONVERSATION_START;
  }

  get workflowsSetupTriggerType(): string[] {
    return [WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION];
  }
}
